import { BasicFieldInputs } from '../components/BasicFieldInputs';
import { Select, Stack } from '@mantine/core';
import { useIntl } from 'react-intl';

export const DisclaimerField = ({
  field,
  setField,
}: {
  field: any;
  setField: (field: any) => void;
}) => {
  const intl = useIntl();
  return (
    <Stack gap="md">
      <BasicFieldInputs
        fields={['title', 'description']}
        fieldValues={field}
        requiredFields={['title']}
        onChange={(key, value) => setField({ ...field, [key]: value })}
      />
      <Select
        label={intl.formatMessage({ id: 'variant' })}
        name="variant"
        value={field.variant}
        placeholder={`${intl.formatMessage({ id: 'select' })}...`}
        withAsterisk
        onChange={(value) => setField({ ...field, variant: value })}
        data={['informative', 'negative', 'neutral', 'notice', 'positive'].map(
          (key: string) => ({
            value: key,
            label: intl.formatMessage({ id: key }),
          })
        )}
      />
    </Stack>
  );
};
